
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/glossary",
      function () {
        return require("private-next-pages/glossary/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/glossary"])
      });
    }
  